import ReactGA from 'react-ga4';

// Replace 'G-XXXXXXXXXX' with your actual Measurement ID from Google Analytics
const TRACKING_ID = "G-2V1QX0W8QJ";

export const initGA = () => {
    ReactGA.initialize(TRACKING_ID);
};

export const logPageView = (path: string) => {
    ReactGA.send({ hitType: "pageview", page: path });
};

export const logEvent = (category: string, action: string, label?: string) => {
    ReactGA.event({
        category: category,
        action: action,
        label: label,
    });
};